export const Data = [
  {
    type: "zh",
    numList : [
      {
        num : "1",
        tital : "牙周病治疗",
        path: "yz"
      },
      {
        num : "2",
        tital : "儿童牙病治疗",
        path: "gxx"
      },
    ],
    imgBoxUrl:"https://www.victrum.com/image//nr/tp/lcyy.jpg",
    itemList:[
      {
        path:"mx1",
        text1:"铒激光在拆除固定桥的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/美学修复/拆除固定桥.mp4",
        text2:""
      },
      {
        path:"mx2",
        text1:"铒激光在拆除牙冠的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/美学修复/拆除牙冠——使用Clipchamp制作.mp4",
        text2:""
      },
      {
        path:"mx3",
        text1:"铒激光在牙龈脱色治疗中的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/美学修复/铒激光在牙龈脱色治疗中的应用.mp4",
        text2:""
      },
      {
        path:"mx4",
        text1:"铒激光在去除瓷贴面的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/美学修复/去瓷贴面.mp4",
        text2:""
      },
      {
        path:"mx5",
        text1:"铒激光在取冠的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/美学修复/激光取冠.mp4",
        text2:""
      },

      {
        path:"wk1",
        text1:"铒激光在种植二期手术中的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/外科种植/种植二期手术.mp4",
        text2:""
      },
      {
        path:"wk2",
        text1:"铒激光在种植体周围炎的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/外科种植/种植体周围炎.mp4",
        text2:""
      },
      {
        path:"wk3",
        text1:"铒激光在种植二期手术中的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/外科种植/种植二期手术--2.mp4",
        text2:""
      },
      {
        path:"wk4",
        text1:"铒激光在种植体二期手术中的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/外科种植/种植体二期手术.mp4",
        text2:""
      },
      {
        path:"wk5",
        text1:"铒激光在种植二期手术中的应用",
        videoUrl:"https://www.victrum.com/image/blsp/外科种植/种植二期手术-3.mp4",
        text2:""
      },


      {
        path:"yt1",
        text1:"铒激光在24窝沟龋治疗中的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/牙体牙髓/24窝沟龋.mp4",
        text2:""
      },
      {
        path:"yt2",
        text1:"铒激光在根管荡洗中的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/牙体牙髓/根管荡洗.mp4",
        text2:""
      },
      {
        path:"yt3",
        text1:"铒激光在活髓切断中的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/牙体牙髓/活髓切端.mp4",
        text2:""
      },
      {
        path:"yt4",
        text1:"铒激光在楔状缺损去腐中的应用",
        videoUrl:"https://www.victrum.com/image/blsp/牙体牙髓/楔状缺损激光去腐.mp4",
        text2:""
      },
      {
        path:"yt5",
        text1:"铒激光在牙本质脱敏中的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/牙体牙髓/牙本质脱敏.mp4",
        text2:""
      },


      {
        path:"yz1",
        text1:"铒激光在重度牙周炎治疗中的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/牙周疾病/重度牙周炎.mp4",
        text2:""
      },
      {
        path:"yz2",
        text1:"铒激光在切除牙龈瘤治疗中的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/牙周疾病/切除牙龈瘤.mp4",
        text2:""
      },
      {
        path:"yz3",
        text1:"铒激光在治疗阿弗他溃疡中的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/牙周疾病/阿弗他溃疡.mp4",
        text2:""
      },
      {
        path:"yz4",
        text1:"铒激光在切龈治疗中的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/牙周疾病/激光切龈.mp4",
        text2:""
      },
      {
        path:"yz5",
        text1:"铒激光在牙周袋清创中的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/牙周疾病/牙周袋清创.mp4",
        text2:""
      },



      {
        path:"zq1",
        text1:"铒激光在导萌术中的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/正畸儿牙/导萌术——使用Clipchamp制作 (1).mp4",
        text2:""
      },
      {
        path:"zq2",
        text1:"铒激光在龋齿治疗中的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/正畸儿牙/激光龋齿治疗.mp4",
        text2:""
      },
      {
        path:"zq3",
        text1:"铒激光在去龋中的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/正畸儿牙/激光去龋.mp4",
        text2:""
      },
      {
        path:"zq4",
        text1:"铒激光在助萌术中的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/正畸儿牙/激光助萌.mp4",
        text2:""
      },
      {
        path:"zq5",
        text1:"铒激光在系带切除中的临床应用",
        videoUrl:"https://www.victrum.com/image/blsp/正畸儿牙/系带切除.mp4",
        text2:""
      },
      // {
      //   path:"yz",
      //   text1:"牙周病治疗",
      //   imageUrl:"https://www.victrum.com/image/nr/lcyy/item.jpg",
      //   text2:"牙周病是一种由菌斑微生物引起的慢性传染性疾病，主要分为仅影响牙龈组织的牙龈病和涉及深层牙周组织（如牙周膜、牙槽骨、牙骨质）的牙周炎两大类。随着激光技术的不断进步，激光及其辅助治疗为牙周病的非手术治疗开辟了新的领域。在众多激光波长中，铒激光凭借其优越的安全性和疗效，已广泛应用于牙周病治疗的各个环节。\n" +
      //     "Er:YAG激光属于中红外线激光，波长为2.94μm，与水（2.95μm）和羟磷灰石中的OH-（2.8μm）的红外线吸收峰值非常接近，使其在含水环境中成为所有波长激光中最易被吸收的一种。因此，Er:YAG激光不仅能够安全、有效地切割牙体硬组织，还可精确处理软组织，且不会对邻近组织产生热损伤。此外，它还具有杀菌、消毒、无痛、出血少等优点。\n" +
      //     "相比传统治疗方法，Er:YAG激光在治疗过程中显著降低了患者的不适感和疼痛感，同时极大减少了震动感，从而有效缓解了患者在口腔治疗中的痛苦和恐惧。这使得激光技术在现代口腔治疗中成为一种更加舒适且高效的选择。\n" +
      //     "\n" +
      //     "小贴士：\n" +
      //     "牙周病的病因\n" +
      //     "1、菌斑与牙石：牙周病的主要病因是牙菌斑的形成。菌斑是一种由细菌、食物残渣和唾液共同形成的生物膜，附着在牙齿表面。如果不及时清除，菌斑会矿化形成牙石，进一步引发牙龈炎和牙周炎。牙石的存在不仅容易滋生更多细菌，还会导致牙龈炎症，进而破坏牙周组织。\n" +
      //     "2、不良口腔卫生习惯：不规律或不正确的刷牙和口腔护理习惯会导致牙菌斑堆积，增加牙周病的风险。如果不使用牙线或牙间刷清洁牙缝，菌斑容易在牙缝中积聚，导致牙周组织受到影响。\n" +
      //     "3、吸烟：吸烟是牙周病的重要诱因之一。烟草中的化学物质会抑制口腔的免疫反应，降低牙龈组织的自我修复能力，增加牙周病的发生风险。此外，吸烟者的牙周组织血液循环较差，影响了牙周病的早期发现和治疗。\n" +
      //     "4、全身性疾病：一些全身性疾病，如糖尿病，会加重牙周病的发生和发展。糖尿病患者的免疫力较低，口腔中的细菌更容易导致牙周组织感染。同时，牙周病的存在也可能影响糖尿病的控制。\n" +
      //     "5、遗传因素：部分人群可能因为遗传原因，对牙周病的易感性较高。这些人即使保持良好的口腔卫生，仍然可能比常人更容易患上牙周病。\n" +
      //     "6、咬合创伤：不良咬合、牙齿排列不齐或咬合力不平衡可能导致局部牙齿承受过大的压力，进而引发牙周组织的损伤，加速牙周病的发生。\n" +
      //     "牙周病的预防\n" +
      //     "1、保持良好的口腔卫生：\n" +
      //     "（1）正确刷牙：每天早晚刷牙，使用含氟牙膏，采用正确的刷牙方法（如巴氏刷牙法），清洁牙龈边缘和牙缝区域，防止菌斑堆积。\n" +
      //     "（2）使用牙线或牙间刷：除了刷牙，使用牙线或牙间刷清洁牙齿之间的缝隙，防止食物残渣和菌斑在这些部位积聚。\n" +
      //     "2、定期口腔检查和洁牙：\n" +
      //     "（1）每半年到一年进行一次口腔检查，及早发现和治疗牙龈炎、牙周炎等问题。（2）定期进行专业洁牙（洗牙），去除牙菌斑和牙石，防止牙周病的发生和发展。\n" +
      //     "3、戒烟：\n" +
      //     "（1）吸烟是牙周病的高危因素之一，戒烟不仅有助于口腔健康，也有利于全身健康。\n" +
      //     "4、保持健康的饮食习惯：\n" +
      //     "（1）维持营养均衡的饮食，尤其是摄入足够的维生素C、钙和蛋白质，有助于维持牙周组织的健康。\n" +
      //     "（2）限制糖分摄入，减少细菌滋生的机会，防止牙菌斑的形成。\n" +
      //     "5、控制全身性疾病：\n" +
      //     "（1）尤其是糖尿病患者，需严格控制血糖水平，定期检查牙周健康情况，防止牙周病的加重。\n" +
      //     "6、避免不良咬合与牙齿损伤：\n" +
      //     "（1）及时矫正牙齿排列不齐等问题，避免咬合不正引起的牙周损伤。\n" +
      //     "（2）防止牙齿受外伤，避免对牙周组织造成额外损害。\n" +
      //     "通过保持良好的口腔卫生习惯、定期进行口腔检查和洁牙，以及避免不良生活习惯等，可以有效预防牙周病的发生和发展。"
      // },
      // {
      //   path:"qctm",
      //   text1:"传统方法与铒激光去瓷贴面的对比",
      //   videoUrl:"https://www.victrum.com/image/sp/qctm.mp4",
      //   text2:"传统方法：使用高速旋转的车针，通过机械研磨的方式将瓷贴面及其粘接剂去除。\n" +
      //     "依赖医生的经验和手感，难以精确控制磨除量，容易损伤健康牙体组织。\n" +
      //     "对牙齿组织有一定程度的机械损伤，可能造成牙齿敏感。\n" +
      //     "车针高速旋转会产生热量，可能导致牙髓损伤。\n" +
      //     "振动和噪音较大，患者可能会感到不适和紧张，通常需要麻醉。\n" +
      //     "操作耗时较长，尤其对于多个贴面的去除。\n" +
      //     "\n" +
      //     "2940nm铒激光：利用2940nm波长的激光，其能量被水和羟基磷灰石高效吸收，产生微爆破效应，汽化粘接剂，使贴面松动脱落。\n" +
      //     "定向作用于粘接剂，精确控制去除范围和深度，最大限度保护牙齿。\n" +
      //     "微创操作，最大限度减少对牙齿组织的损伤，术后不适感更轻。"
      // },
      // {
      //   path:"yytszl",
      //   text1:"铒激光在牙龈脱色治疗中的应用",
      //   videoUrl:"https://www.victrum.com/image/sp/yytszl.mp4",
      //   text2:"2940铒激光是一种常用的口腔激光，在牙龈美白方面具有独特的优势。其主要优势如下：\n" +
      //     "1、精确性高：2940铒激光可以精确地作用于牙龈的色素沉着部位，避免损伤周围的健康组织，确保治疗效果的同时最大程度地减少不适感。\n" +
      //     "2、创伤小：2940铒激光治疗是一种微创手术，术后肿胀和疼痛感较轻，患者更容易接受。\n" +
      //     "3、效果显著：经过2940铒激光治疗，牙龈的颜色可以明显改善，呈现出更健康、更自然的粉色。\n" +
      //     "4、操作简便：对于医生来说，2940铒激光操作简单，易于掌握，可以缩短治疗时间。"
      // },
      // {
      //   path:"ggdx",
      //   text1:"铒激光在根管荡洗中的应用",
      //   videoUrl:"https://www.victrum.com/image/sp/ggdx.mp4",
      //   text2:"Er:YAG激光与冲洗剂可产生协同作用，激光产生的能量被水强烈吸收，在根管冲洗液中产生蒸汽和气泡，并发生光机械效应。\n" +
      //     "这些气泡形成和内爆产生的冲击波使液体快速移动，在根管壁产生剪切应力，从而清除根管壁的碎屑，破坏玷污层。\n" +
      //     "同时光机械作用还可以提高冲洗液的化学性能和渗透性，有效去除玷污层。\n"
      // },
      // {
      //   path:"sdqz",
      //   text1:"铒激光在深度去龋治疗中的应用",
      //   videoUrl:"https://www.victrum.com/image/sp/sdqz.mp4",
      //   text2:"铒激光在深度去龋方面具有显著的优势，主要体现在以下几个方面：\n" +
      //     "1、选择性去除龋坏组织：铒激光对水和羟基磷灰石具有高度选择性吸收，能够精确去除龋坏组织，而对健康牙体组织的损伤较小，从而最大程度地保留牙体组织。\n" +
      //     "2、微创治疗：铒激光切割深度精确，创口小，出血少，愈合快，可有效减少患者的疼痛感，提高治疗舒适度。\n" +
      //     "3、减少热损伤：铒激光产生的热量较少，对牙髓的热损伤远低于传统钻削工具，有效降低了牙髓坏死风险。\n" +
      //     "4、无菌操作：铒激光治疗过程无需接触牙齿，避免了交叉感染的风险，提高了治疗安全性。\n" +
      //     "适用于多种临床情况：铒激光可用于各种龋病的治疗，包括浅龋、中龋和深龋，尤其适用于儿童和对疼痛敏感的患者。\n" +
      //     "\n"
      // },
      // {
      //   path:"yctm",
      //   text1:"铒激光在牙齿脱敏治疗中的应用",
      //   videoUrl:"https://www.victrum.com/image/sp/yctm.mp4",
      //   text2:"铒激光治疗牙齿脱敏是一种越来越受欢迎的口腔治疗方法，它具有以下优势：\n" +
      //     "1、高效封闭牙本质小管：铒激光能精确地作用于暴露的牙本质小管，通过热作用熔融小管口，形成一层致密的封闭层，有效阻断外界刺激，缓解疼痛。\n" +
      //     "2、快速止痛效果：与传统脱敏方法相比，铒激光治疗起效迅速，患者通常能立即感受到疼痛缓解。\n" +
      //     "3、持久效果：铒激光治疗的脱敏效果持久，远期疗效稳定。\n"
      // },
      // {
      //   path:"zzeq",
      //   text1:"铒激光在种植体二期手术中的应用",
      //   videoUrl:"https://www.victrum.com/image/sp/zzeq.mp4",
      //   text2:"铒激光在种植体二期手术中展现出诸多优势，主要体现在以下几个方面：\n" +
      //     "1、止血效果好：激光照射组织后，能够迅速凝固血管，减少出血，缩短手术时间，提高患者舒适度。\n" +
      //     "2、精准切割：铒激光具有极高的切割精度，能够精确地去除软硬组织，避免对周围组织的损伤，从而获得更好的手术效果。\n" +
      //     "3、杀菌作用：铒激光具有良好的杀菌作用，能够有效杀灭手术部位的细菌，降低感染风险。\n" +
      //     "4、创口愈合快：激光切口具有良好的愈合特性，创口愈合速度快，减少术后疼痛和肿胀。\n" +
      //     "5、患者舒适度高：激光治疗创伤小，疼痛感轻，患者舒适度高。"
      // },
      // {
      //   path:"zztzwy",
      //   text1:"铒激光在种植体周围炎治疗中的应用",
      //   videoUrl:"https://www.victrum.com/image/sp/zztzwy.mp4",
      //   text2:"铒激光治疗种植体周围炎具有以下优势：\n" +
      //     "1、精确性高：铒激光能精确去除病变组织，对周围健康组织损伤小，保护种植体表面。\n" +
      //     "2、杀菌效果显著：激光的高温能有效杀灭种植体周围的细菌，抑制炎症。\n" +
      //     "3、促进愈合：激光照射能刺激组织再生，促进伤口愈合，缩短恢复期。\n" +
      //     "种植体表面腐烂组织及肉芽清洁畅快。"
      // }
    ]
  },
  {
    type: "en",
    numList : [
      {
        num : "1",
        tital : "牙周病治疗",
        path: "yz"
      },
      {
        num : "2",
        tital : "儿童牙病治疗",
        path: "gxx"
      },
    ],
    imgBoxUrl:"https://www.victrum.com/image//nr/tp/lcyy.jpg",
    itemList:[

      {
        path:"mx1",
        text1:"Clinical Application of Erbium Laser in Removing Fixed Bridges",
        videoUrl:"https://www.victrum.com/image/blsp/美学修复/拆除固定桥.mp4",
        text2:""
      },
      {
        path:"mx2",
        text1:"Clinical Application of Erbium Laser in Removing Dental Crowns",
        videoUrl:"https://www.victrum.com/image/blsp/美学修复/拆除牙冠——使用Clipchamp制作.mp4",
        text2:""
      },
      {
        path:"mx3",
        text1:"Clinical Application of Erbium Laser in Gingival Depigmentation",
        videoUrl:"https://www.victrum.com/image/blsp/美学修复/铒激光在牙龈脱色治疗中的应用.mp4",
        text2:""
      },
      {
        path:"mx4",
        text1:"Clinical Application of Erbium Laser in Removing Porcelain Veneers",
        videoUrl:"https://www.victrum.com/image/blsp/美学修复/去瓷贴面.mp4",
        text2:""
      },
      {
        path:"mx5",
        text1:"Clinical Application of Erbium Laser in Crown Removal",
        videoUrl:"https://www.victrum.com/image/blsp/美学修复/激光取冠.mp4",
        text2:""
      },

      {
        path:"wk1",
        text1:"Clinical Application of Erbium Laser in Second-Stage Implant Surgery",
        videoUrl:"https://www.victrum.com/image/blsp/外科种植/种植二期手术.mp4",
        text2:""
      },
      {
        path:"wk2",
        text1:"Clinical Application of Erbium Laser in Peri-Implantitis",
        videoUrl:"https://www.victrum.com/image/blsp/外科种植/种植体周围炎.mp4",
        text2:""
      },
      {
        path:"wk3",
        text1:"Clinical Application of Erbium Laser in Second-Stage Implant Surgery",
        videoUrl:"https://www.victrum.com/image/blsp/外科种植/种植二期手术--2.mp4",
        text2:""
      },
      {
        path:"wk4",
        text1:"Clinical Application of Erbium Laser in Second-Stage Implant Surgery",
        videoUrl:"https://www.victrum.com/image/blsp/外科种植/种植体二期手术.mp4",
        text2:""
      },
      {
        path:"wk5",
        text1:"Application of Erbium Laser in Second-Stage Implant Surgery",
        videoUrl:"https://www.victrum.com/image/blsp/外科种植/种植二期手术-3.mp4",
        text2:""
      },


      {
        path:"yt1",
        text1:"Clinical Application of Erbium Laser in Treatment of Occlusal Caries",
        videoUrl:"https://www.victrum.com/image/blsp/牙体牙髓/24窝沟龋.mp4",
        text2:""
      },
      {
        path:"yt2",
        text1:"Clinical Application of Erbium Laser in Root Canal Irrigation",
        videoUrl:"https://www.victrum.com/image/blsp/牙体牙髓/根管荡洗.mp4",
        text2:""
      },
      {
        path:"yt3",
        text1:"Clinical Application of Erbium Laser in Pulpotomy",
        videoUrl:"https://www.victrum.com/image/blsp/牙体牙髓/活髓切端.mp4",
        text2:""
      },
      {
        path:"yt4",
        text1:"Application of Erbium Laser in Caries Removal for Wedge-Shaped Defects",
        videoUrl:"https://www.victrum.com/image/blsp/牙体牙髓/楔状缺损激光去腐.mp4",
        text2:""
      },
      {
        path:"yt5",
        text1:"Clinical Application of Erbium Laser in Dentin Hypersensitivity",
        videoUrl:"https://www.victrum.com/image/blsp/牙体牙髓/牙本质脱敏.mp4",
        text2:""
      },


      {
        path:"yz1",
        text1:"Clinical Application of Erbium Laser in Treatment of Severe Periodontitis",
        videoUrl:"https://www.victrum.com/image/blsp/牙周疾病/重度牙周炎.mp4",
        text2:""
      },
      {
        path:"yz2",
        text1:"Clinical Application of Erbium Laser in Resection of Epulis",
        videoUrl:"https://www.victrum.com/image/blsp/牙周疾病/切除牙龈瘤.mp4",
        text2:""
      },
      {
        path:"yz3",
        text1:"Clinical Application of Erbium Laser in Treatment of Aphthous Ulcers",
        videoUrl:"https://www.victrum.com/image/blsp/牙周疾病/阿弗他溃疡.mp4",
        text2:""
      },
      {
        path:"yz4",
        text1:"Clinical Application of Erbium Laser in Gingivectomy",
        videoUrl:"https://www.victrum.com/image/blsp/牙周疾病/激光切龈.mp4",
        text2:""
      },
      {
        path:"yz5",
        text1:"Clinical Application of Erbium Laser in Periodontal Pocket Debridement",
        videoUrl:"https://www.victrum.com/image/blsp/牙周疾病/牙周袋清创.mp4",
        text2:""
      },



      {
        path:"zq1",
        text1:"Clinical Application of Erbium Laser in Exposure of Impacted Teeth",
        videoUrl:"https://www.victrum.com/image/blsp/正畸儿牙/导萌术——使用Clipchamp制作 (1).mp4",
        text2:""
      },
      {
        path:"zq2",
        text1:"Clinical Application of Erbium Laser in Treatment of Dental Caries",
        videoUrl:"https://www.victrum.com/image/blsp/正畸儿牙/激光龋齿治疗.mp4",
        text2:""
      },
      {
        path:"zq3",
        text1:"Clinical Application of Erbium Laser in Caries Removal",
        videoUrl:"https://www.victrum.com/image/blsp/正畸儿牙/激光去龋.mp4",
        text2:""
      },
      {
        path:"zq4",
        text1:"Clinical Application of Erbium Laser in Assisting Eruption of Impacted Teeth",
        videoUrl:"https://www.victrum.com/image/blsp/正畸儿牙/激光助萌.mp4",
        text2:""
      },
      {
        path:"zq5",
        text1:"Clinical Application of Erbium Laser in Frenectomy",
        videoUrl:"https://www.victrum.com/image/blsp/正畸儿牙/系带切除.mp4",
        text2:""
      },

      // {
      //   path:"yz",
      //   text1:"牙周病治疗",
      //   imageUrl:"https://www.victrum.com/image/nr/lcyy/item.jpg",
      //   text2:"牙周病是一种由菌斑微生物引起的慢性传染性疾病，主要分为仅影响牙龈组织的牙龈病和涉及深层牙周组织（如牙周膜、牙槽骨、牙骨质）的牙周炎两大类。随着激光技术的不断进步，激光及其辅助治疗为牙周病的非手术治疗开辟了新的领域。在众多激光波长中，铒激光凭借其优越的安全性和疗效，已广泛应用于牙周病治疗的各个环节。\n" +
      //     "Er:YAG激光属于中红外线激光，波长为2.94μm，与水（2.95μm）和羟磷灰石中的OH-（2.8μm）的红外线吸收峰值非常接近，使其在含水环境中成为所有波长激光中最易被吸收的一种。因此，Er:YAG激光不仅能够安全、有效地切割牙体硬组织，还可精确处理软组织，且不会对邻近组织产生热损伤。此外，它还具有杀菌、消毒、无痛、出血少等优点。\n" +
      //     "相比传统治疗方法，Er:YAG激光在治疗过程中显著降低了患者的不适感和疼痛感，同时极大减少了震动感，从而有效缓解了患者在口腔治疗中的痛苦和恐惧。这使得激光技术在现代口腔治疗中成为一种更加舒适且高效的选择。\n" +
      //     "\n" +
      //     "小贴士：\n" +
      //     "牙周病的病因\n" +
      //     "1、菌斑与牙石：牙周病的主要病因是牙菌斑的形成。菌斑是一种由细菌、食物残渣和唾液共同形成的生物膜，附着在牙齿表面。如果不及时清除，菌斑会矿化形成牙石，进一步引发牙龈炎和牙周炎。牙石的存在不仅容易滋生更多细菌，还会导致牙龈炎症，进而破坏牙周组织。\n" +
      //     "2、不良口腔卫生习惯：不规律或不正确的刷牙和口腔护理习惯会导致牙菌斑堆积，增加牙周病的风险。如果不使用牙线或牙间刷清洁牙缝，菌斑容易在牙缝中积聚，导致牙周组织受到影响。\n" +
      //     "3、吸烟：吸烟是牙周病的重要诱因之一。烟草中的化学物质会抑制口腔的免疫反应，降低牙龈组织的自我修复能力，增加牙周病的发生风险。此外，吸烟者的牙周组织血液循环较差，影响了牙周病的早期发现和治疗。\n" +
      //     "4、全身性疾病：一些全身性疾病，如糖尿病，会加重牙周病的发生和发展。糖尿病患者的免疫力较低，口腔中的细菌更容易导致牙周组织感染。同时，牙周病的存在也可能影响糖尿病的控制。\n" +
      //     "5、遗传因素：部分人群可能因为遗传原因，对牙周病的易感性较高。这些人即使保持良好的口腔卫生，仍然可能比常人更容易患上牙周病。\n" +
      //     "6、咬合创伤：不良咬合、牙齿排列不齐或咬合力不平衡可能导致局部牙齿承受过大的压力，进而引发牙周组织的损伤，加速牙周病的发生。\n" +
      //     "牙周病的预防\n" +
      //     "1、保持良好的口腔卫生：\n" +
      //     "（1）正确刷牙：每天早晚刷牙，使用含氟牙膏，采用正确的刷牙方法（如巴氏刷牙法），清洁牙龈边缘和牙缝区域，防止菌斑堆积。\n" +
      //     "（2）使用牙线或牙间刷：除了刷牙，使用牙线或牙间刷清洁牙齿之间的缝隙，防止食物残渣和菌斑在这些部位积聚。\n" +
      //     "2、定期口腔检查和洁牙：\n" +
      //     "（1）每半年到一年进行一次口腔检查，及早发现和治疗牙龈炎、牙周炎等问题。（2）定期进行专业洁牙（洗牙），去除牙菌斑和牙石，防止牙周病的发生和发展。\n" +
      //     "3、戒烟：\n" +
      //     "（1）吸烟是牙周病的高危因素之一，戒烟不仅有助于口腔健康，也有利于全身健康。\n" +
      //     "4、保持健康的饮食习惯：\n" +
      //     "（1）维持营养均衡的饮食，尤其是摄入足够的维生素C、钙和蛋白质，有助于维持牙周组织的健康。\n" +
      //     "（2）限制糖分摄入，减少细菌滋生的机会，防止牙菌斑的形成。\n" +
      //     "5、控制全身性疾病：\n" +
      //     "（1）尤其是糖尿病患者，需严格控制血糖水平，定期检查牙周健康情况，防止牙周病的加重。\n" +
      //     "6、避免不良咬合与牙齿损伤：\n" +
      //     "（1）及时矫正牙齿排列不齐等问题，避免咬合不正引起的牙周损伤。\n" +
      //     "（2）防止牙齿受外伤，避免对牙周组织造成额外损害。\n" +
      //     "通过保持良好的口腔卫生习惯、定期进行口腔检查和洁牙，以及避免不良生活习惯等，可以有效预防牙周病的发生和发展。"
      // },
      // {
      //   path:"qctm",
      //   text1:"Comparison Between The Traditional Method And The Er:YAG Laser Method For Removing Porcelain Veneers",
      //   videoUrl:"https://www.victrum.com/image/sp/qctm.mp4",
      //   text2:"Traditional Method: Use a high-speed rotating bur to remove the porcelain veneer and its adhesive through mechanical grinding.\n" +
      //     "It relies on the doctor's experience and tactile sense. It is difficult to precisely control the amount of grinding, and it is easy to damage the healthy dental tissues.\n" +
      //     "There is a certain degree of mechanical damage to the dental tissues, which may cause tooth sensitivity.\n" +
      //     "The high-speed rotation of the bur will generate heat, which may lead to pulp damage.\n" +
      //     "There is a large amount of vibration and noise, and patients may feel uncomfortable and nervous. Usually, anesthesia is required.\n" +
      //     "The operation takes a long time, especially for the removal of multiple veneers.\n" +
      //     "2940nm Er:YAG Laser: Utilize the laser with a wavelength of 2940nm. Its energy is efficiently absorbed by water and hydroxyapatite, generating a micro-explosion effect, vaporizing the adhesive, and making the veneer loose and fall off.\n" +
      //     "It acts on the adhesive in a directional manner, precisely controlling the removal range and depth, and protecting the teeth to the greatest extent.\n" +
      //     "It is a minimally invasive operation, minimizing the damage to the dental tissues to the greatest extent, and the postoperative discomfort is milder."
      // },
      // {
      //   path:"yytszl",
      //   text1:"Application Of Er:YAG Laser In Gingival Depigmentation Treatment",
      //   videoUrl:"https://www.victrum.com/image/sp/yytszl.mp4",
      //   text2:"The 2940 Er:YAG laser is a commonly used oral laser and has unique advantages in gingival whitening. Its main advantages are as follows:\n" +
      //     "1、High precision: The 2940 Er:YAG laser can precisely act on the pigmented areas of the gingiva, avoiding damage to the surrounding healthy tissues, ensuring the treatment effect while minimizing discomfort to the greatest extent.\n" +
      //     "2、Minimal trauma: Treatment with the 2940 Er:YAG laser is a minimally invasive procedure. The postoperative swelling and pain are mild, making it more acceptable to patients.\n" +
      //     "3、Remarkable effect: After treatment with the 2940 Er:YAG laser, the color of the gingiva can be significantly improved, presenting a healthier and more natural pink color.\n" +
      //     "4、Easy operation: For doctors, the operation of the 2940 Er:YAG laser is simple and easy to master, which can shorten the treatment time."
      // },
      // {
      //   path:"ggdx",
      //   text1:"The Application Of Er:YAG Laser In Root Canal Irrigation",
      //   videoUrl:"https://www.victrum.com/image/sp/ggdx.mp4",
      //   text2:"The Er:YAG laser can produce a synergistic effect with the irrigant. The energy generated by the laser is strongly absorbed by water, generating steam and bubbles in the root canal irrigant and triggering a photo-mechanical effect.\n" +
      //     "\n" +
      //     "The shock waves generated by the formation and implosion of these bubbles cause the liquid to move rapidly, creating shear stress on the root canal wall, thereby removing the debris on the root canal wall and disrupting the smear layer.\n" +
      //     "\n" +
      //     "At the same time, the photo-mechanical effect can also enhance the chemical properties and permeability of the irrigant, effectively removing the smear layer."
      // },
      // {
      //   path:"sdqz",
      //   text1:"The Application Of Er:YAG Laser In Deep Caries Removal Treatment",
      //   videoUrl:"https://www.victrum.com/image/sp/sdqz.mp4",
      //   text2:"The Er:YAG laser has significant advantages in deep caries removal, which are mainly reflected in the following aspects:\n" +
      //     "\n" +
      //     "1、Selective removal of carious tissues: The Er:YAG laser has a high degree of selective absorption of water and hydroxyapatite. It can precisely remove carious tissues while causing less damage to healthy dental tissues, thus preserving the dental tissues to the greatest extent.\n" +
      //     "2、Minimally invasive treatment: The Er:YAG laser has precise cutting depth, small wound, less bleeding and fast healing. It can effectively reduce the patient's pain and improve the comfort of treatment.\n" +
      //     "3、Reduced thermal damage: The Er:YAG laser generates less heat, and the thermal damage to the dental pulp is much lower than that of traditional drilling tools, effectively reducing the risk of pulp necrosis.\n" +
      //     "4、Aseptic operation: During the treatment with the Er:YAG laser, there is no need to contact the teeth, avoiding the risk of cross-infection and improving the safety of treatment.\n" +
      //     "Applicable to a variety of clinical situations: The Er:YAG laser can be used for the treatment of various dental caries, including shallow caries, moderate caries and deep caries, especially suitable for children and patients who are sensitive to pain."
      // },
      // {
      //   path:"yctm",
      //   text1:"The Application Of Er:YAG Laser In Tooth Desensitization Treatment",
      //   videoUrl:"https://www.victrum.com/image/sp/yctm.mp4",
      //   text2:"The treatment of tooth desensitization with Er:YAG laser is an increasingly popular oral treatment method, which has the following advantages:\n" +
      //     "\n" +
      //     "1、Efficiently seal the dentinal tubules: The Er:YAG laser can precisely act on the exposed dentinal tubules. Through the thermal effect, it can melt the orifices of the tubules to form a dense sealing layer, effectively blocking external stimuli and relieving pain.\n" +
      //     "2、Rapid pain relief effect: Compared with traditional desensitization methods, the treatment with Er:YAG laser takes effect quickly, and patients can usually feel the pain relief immediately.\n" +
      //     "3、Durable effect: The desensitization effect of the treatment with Er:YAG laser is long-lasting, and the long-term curative effect is stable."
      // },
      // {
      //   path:"zzeq",
      //   text1:"The Application Of Er:YAG Laser In The Second - Stage Implant Surgery",
      //   videoUrl:"https://www.victrum.com/image/sp/zzeq.mp4",
      //   text2:"The  Er:YAG laser shows many advantages in the second-stage implant surgery, which are mainly reflected in the following aspects:\n" +
      //     "\n" +
      //     "1、Good hemostatic effect: After the laser irradiates the tissue, it can rapidly coagulate the blood vessels, reduce bleeding, shorten the operation time, and improve the patient's comfort.\n" +
      //     "2、Precise cutting: The  Er:YAG laser has extremely high cutting precision and can accurately remove the soft and hard tissues, avoiding damage to the surrounding tissues, thus achieving a better surgical effect.\n" +
      //     "3、Bactericidal effect: The  Er:YAG laser has a good bactericidal effect, which can effectively kill the bacteria at the surgical site and reduce the risk of infection.\n" +
      //     "4、Fast wound healing: The laser incision has good healing characteristics, with a fast wound healing speed, reducing postoperative pain and swelling.\n" +
      //     "5、High patient comfort: Laser treatment has minimal trauma and mild pain, providing a high level of comfort for patients.\n"
      // },
      // {
      //   path:"zztzwy",
      //   text1:"The Application Of Er:YAG Laser In The Treatment Of Peri - Implantitis",
      //   videoUrl:"https://www.victrum.com/image/sp/zztzwy.mp4",
      //   text2:"The treatment of peri-implantitis with erbium laser has the following advantages:\n" +
      //     "\n" +
      //     "1、High precision: The Er:YAG laser can accurately remove the diseased tissue, causing minimal damage to the surrounding healthy tissue and protecting the surface of the implant.\n" +
      //     "2、Remarkable bactericidal effect: The high temperature of the laser can effectively kill the bacteria around the implant and inhibit inflammation.\n" +
      //     "3、Promote healing: Laser irradiation can stimulate tissue regeneration, accelerate wound healing, and shorten the recovery period.\n" +
      //     "\n" +
      //     "It can clean the decayed tissue and granulation on the surface of the implant smoothly and thoroughly."
      // }
    ]
  },
]



// WEBPACK FOOTER //
// ./src/components/js/clinical.js